const { get } = require("lodash");

const getError = (action) => {
  return get(action, "error.message", null);
};

export { getError };
